
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
    switchPopupCreateAction,
    setCreatingWriteAction
} from './actions';
import {
    setCreatingWriteWSAction
} from './actionsWS';
import './style.scss';

const plusIcon = '//schedule-dist.redken.online/v1/client/assets/plus.svg';

class TicketItem extends React.Component {
    switchCreatePopup = () => {
        const {
            dispatch,
            ticket
        } = this.props;

        dispatch(setCreatingWriteAction('SET', ticket));

        dispatch(switchPopupCreateAction());
    }

    render() {
        const { ticket } = this.props;

        const ticketEditing = ticket.status === 'editing';
        const timeTicket = [moment(ticket.time_start).format('HH:mm'), moment(ticket.time_end).format('HH:mm')];

        switch (ticket.status) {
            case 'free':
            case 'editing': {
                return (
                    <div className="schedule_ticket">
                        <button
                            type="button"
                            className={`ticket free ${ticketEditing ? 'editing' : ''}`}
                            disabled={ticketEditing}
                            onClick={!ticketEditing ? () => this.switchCreatePopup() : null}
                            style={{ '--bg-icon': `url('${plusIcon}')` }}
                        >
                            {timeTicket[0]}
                            &nbsp;-&nbsp;
                            {timeTicket[1]}
                        </button>
                    </div>
                );
            }
            case 'busy': {
                return (
                    <div className="schedule_ticket">
                        <button
                            type="button"
                            className={`ticket ${ticket.status}`}
                            style={{ '--bg-icon': `url('${plusIcon}')` }}
                            disabled
                        >
                            {timeTicket[0]}
                            &nbsp;-&nbsp;
                            {timeTicket[1]}
                        </button>
                    </div>
                );
            }
            default:
                return null;
        }
    }
}

TicketItem.defaultProps = {
    originalTicket: null
  };

TicketItem.propTypes = {
    dispatch: PropTypes.func.isRequired,
    ticket: PropTypes.object.isRequired,
    originalTicket: PropTypes.object,
    doctor: PropTypes.object.isRequired
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(TicketItem);
